import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  db_select_modal_open: false,
  add_new_db_modal_open: false,
  loading: false,
  error:false,
  error_Message:'',
  edit_mode:false,


  // Add new db states .
  Group_ID: null,
  Connection_Name: "",
  Login_Name: "",
  Password: "",
  IP: "",
  Database_Name: "",
  Type: "", //MYSQL,
  Port: "",
  database_id:null,
  Database_ID:null,


  //DB list.
  DB_List:[],

  // Sample database List .
  Sample_DB_List:[]
};

const Select_DB_Modal = createSlice({
  name: "Select_DB_Modal",
  initialState,
  reducers: {
    
    start_db_connection_modal_loading(state, action) {
        state.loading = true;
      },
    save_new_db_connection_success(state, action) {
        state.add_new_db_modal_open = false;
        state.edit_mode = false
        state.database_id = action.payload
        state.loading = false; 
    },
    save_new_db_connection_fail(state, action) {
        state.add_new_db_modal_open = false;
        state.edit_mode = false
        state.loading = false;
        state.error = true;
        state.error_Message = action.payload 
    },
    

    fetch_db_list_success(state, action) {
        state.loading = false;
        state.DB_List=action.payload
    },

    set_sample_db_connection_success(state, action) {
      // state.loading = false;
      state.Sample_DB_List=action.payload
    },
    set_sample_db_connection_fail(state, action) {
      state.loading = false;
      // state.Sample_DB_List=[]
    },

    fetch_db_list_fail(state, action) {
        state.loading = false;
        state.DB_List=[];
        state.error = true;
        state.error_Message = action.payload
    },


    open_select_db_modal(state, action) {
      state.db_select_modal_open = true;
    },
    close_select_db_modal(state, action) {
      state.db_select_modal_open = false;
    
    },
    open_add_db_modal(state, action) {
      state.add_new_db_modal_open = true;
      state.Connection_Name = ""
      state.Database_Name = "",
      state.IP = ""
      state.Login_Name = ""
      state.Password = ""
      state.Port = ""
      state.Type= ""
      state.Group_ID = ""
      state.Database_ID = ""
      state.edit_mode = false
    },
    open_add_db_modal_in_edit_mode(state, action) {
      const {Connection_Name,
        Database_ID,
        Database_Name,
        Group_ID,
        IP,
        Last_Updated_By,
        Last_Updated_Date,
        Login_Name,
        Password,
        Port,
        Type,
    } = action.payload
    state.Connection_Name = Connection_Name
    state.Database_Name = Database_Name,
    state.IP = IP
    state.Login_Name = Login_Name
    state.Password = Password
    state.Port = Port
    state.Type= Type
    state.Group_ID = Group_ID
    state.Database_ID = Database_ID


      state.add_new_db_modal_open = true;
      state.edit_mode = true

    },
    close_add_db_modal(state, action) {
      state.add_new_db_modal_open = false;
      state.edit_mode = false
    },

    //reducer for adding new db connection .
    set_db_connection_group_id(state, action) {
      state.Group_ID = action.payload;
    },
    set_db_connection_name(state, action) {
      state.Connection_Name = action.payload;
    },
    set_db_connection_login_name(state, action) {
      state.Login_Name = action.payload;
    },
    set_db_connection_password(state, action) {
      state.Password = action.payload;
    },
    set_db_connection_ip(state, action) {
      state.IP = action.payload;
    },
    set_db_connection_db_name(state, action) {
      state.Database_Name = action.payload;
    },
    set_db_connection_type(state, action) {
      state.Type = action.payload;
    },
    set_db_connection_port(state, action) {
      state.Port = action.payload;
    },
    set_selected_database_id(state, action) {
      state.database_id = action.payload;
    },
    resetState() {
      return initialState;
    }
  },
});

export const {
  open_select_db_modal,
  close_select_db_modal,
   open_add_db_modal,
   close_add_db_modal,
   set_sample_db_connection_success,
   set_sample_db_connection_fail,


  set_db_connection_group_id,
  set_db_connection_name,
  set_db_connection_login_name,
  set_db_connection_password,
  set_db_connection_ip,
  set_db_connection_db_name,
  set_db_connection_type,
  set_db_connection_port,
  start_db_connection_modal_loading,
  save_new_db_connection_success,
  save_new_db_connection_fail,
  fetch_db_list_success,
  fetch_db_list_fail,
  set_selected_database_id,
  open_add_db_modal_in_edit_mode
} = Select_DB_Modal.actions;

export default Select_DB_Modal.reducer;
